import { CommonModule } from '@angular/common';
import { Component, inject, signal, viewChild } from '@angular/core';

import { IColumn } from '@app/shared/interceptors/column.interface';
import { SessionService } from '@app/shared/services/session.service';
import { NO_ACTIVITY_DAYS } from '@app/shared/constants/global.constant';
import { ISessionResponse } from '@app/shared/interfaces/session.interface';
import { KioskDetailComponent } from '../kiosk-detail/kiosk-detail.component';
import { TableComponent } from '@shared/components/table-component/table.component';

import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-kiosk-table',
  imports: [CommonModule, TableComponent, KioskDetailComponent, ButtonModule, TooltipModule],
  templateUrl: './kiosk-table.component.html',
})
export class KioskTableComponent {
  sessionService = inject(SessionService);

  statusColumnTemplate = viewChild('statusColumnTemplate');
  detailColumnTemplate = viewChild('detailColumnTemplate');
  nameColumnTemplate = viewChild('nameColumnTemplate');
  kioskDetailDialog = viewChild.required(KioskDetailComponent);
  tableComponent = viewChild.required(TableComponent);

  cols: IColumn[] = [];
  sessionServiceRespone = signal<ISessionResponse | any>({});
  kioskData = signal<ISessionResponse['content']>([]);
  tableLoading = signal<boolean>(false);
  searchFilterValue = signal<string>('');
  noActivityDays = NO_ACTIVITY_DAYS;

  ngOnInit() {
    this.initTableCols();
    this.getSessionForKiosk();
  }

  initTableCols() {
    this.cols = [
      { key: 'name', label: 'Kiosk Name', searchable: true, template: this.nameColumnTemplate() },
      {
        key: 'serverPingInformation.Status',
        label: 'Status',
        template: this.statusColumnTemplate(),
      },
      { key: 'detail', label: '', template: this.detailColumnTemplate() },
    ];
  }

  getSessionForKiosk() {
    const rowSize = this.tableComponent().rowsPerPage();
    const currentPage = this.tableComponent().currentPage() - 1;
    const kioskName = this.searchFilterValue();
    this.tableLoading.set(true);

    this.sessionService.getSessionForKiosk(currentPage, rowSize, kioskName).subscribe({
      next: (response) => {
        this.sessionServiceRespone.set(response);
        this.kioskData.set(response.content);
        this.tableLoading.set(false);
      },
      error: (error) => {
        console.log(error);
        this.tableLoading.set(false);
      },
    });
  }

  onChangePage() {
    this.getSessionForKiosk();
  }

  onSearchFilter(event: any) {
    this.searchFilterValue.set(event);
    this.getSessionForKiosk();
  }

  openDetailDialog(data: any) {
    this.kioskDetailDialog().displayDialog.set(true);
    this.kioskDetailDialog().selectedItem.set(data);
  }
}
